import { useLocation, useNavigate, useParams } from "react-router-dom";
import { UserContext } from "../context/UserContext";
import { useContext, useEffect, useState } from "react";
import { base_url } from '../url_variables';
import axios from 'axios';
import { useCookies } from "react-cookie";
import { GridLoader } from "react-spinners";
import {TopBar} from '../components/topbar';
import { MenuContext } from "../context/MenuContext";
import { SendEmail } from "../components/send_email";
import { IoSearch } from "react-icons/io5";
import { IoMdArrowDropdown, IoMdArrowDropup } from "react-icons/io";
import { MdOutlineWarehouse } from "react-icons/md";
import { BiMoneyWithdraw } from "react-icons/bi";


export default function CustomerOrderHistory() {
    const navigate = useNavigate();
    const {logOutFunction} = useContext(UserContext);
    const [cookies] = useCookies();
    const [formFields, setFormFields] = useState({});
    const [bookingList, setBookingList] = useState([]);
    const [pageLoading, setPageLoading] = useState(true);
    const [offset, setOffset] = useState(0);
    const [pagination] = useState('');
    const { menuOpen, setMenuOpen } = useContext(MenuContext)
    const [pageData, setPageData] = useState({});
    const [showEmailModal, setShowEmailModal] = useState(false);
    const [showDetails, setShowDetails] = useState({});
    const {customer_id} = useParams();
    const {state} = useLocation();

    useEffect(() => {
        if (menuOpen) setMenuOpen(false);
        getData();
    }, [])

    useEffect(() => {
        getData();
    }, [offset, formFields?.order])

    function changePage(type) {
        if (type == "next") {
            setOffset(offset + 20);
        } else {
            setOffset(offset - 20);
        }
    }

    async function getData() {
        const formData = new FormData();
        formData.append('offset', offset);
        formData.append('customer_id', customer_id);
        if (formFields?.order !== undefined) {
            formData.append('order', formFields?.order);
            formData.append('order_by', formFields?.order_by);
        }
        setPageLoading(true)
        try {
            const response = await axios.post(base_url + '/get_customer_order.php', formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    token: cookies?.userProfile?.session,
                    accountid: cookies?.userProfile?.main_id,
                },
            });
            if (response.data.code == 403) {
                logOutFunction()
            }
            setPageLoading(false)
            if (response.data.status) {
              setBookingList(response.data.records);
              setPageData({ total_income: response.data.total_income, total_orders: response.data.total_orders });
            } else {

            }
        } catch (error) {
          setPageLoading(false)
        }
    }

    async function searchData() {
        const formData = new FormData();
        Object.entries(formFields).forEach(([key, value]) => {
          formData.append(key, value);
        });
        formData.append('customer_id', customer_id);
        setPageLoading(true)
        try {
            const response = await axios.post(base_url + '/get_customer_order.php', formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    token: cookies?.userProfile?.session,
                    accountid: cookies?.userProfile?.main_id,
                },
            });
            if (response.data.code == 403) {
                logOutFunction()
            }
            setPageLoading(false)
            if (response.data.status) {
              setBookingList(response.data.records);
            } else {

            }
        } catch (error) {
          setPageLoading(false)
        }
    }

  return (
    <div className="flex flex-col rounded-[10px] min-h-full bg-white">
      {pageLoading && (
      <div className="flex items-center justify-center h-full w-[-webkit-fill-available] z-[99] bg-[#ffffff] fixed opacity-[0.9]">
        <GridLoader
            color={'#7d5af6'}
            loading={true}
            size={20}
            aria-label="Loading Spinner"
            data-testid="loader"
        />
      </div>
      )}
      {showEmailModal &&
        <SendEmail
            setShowEmailModal={setShowEmailModal}
            showEmailModal={showEmailModal}
            showDetails={showDetails}
        />
        }
        {/* <h2 className="text-2xl text-[#037684] font-bold mb-4">Welcome, {userProfile?.name}</h2> */}
        <TopBar title={`Welcome, Admin`} />
        <div className="py-6 px-6 flex flex-col justify-start">
            <div className="gap-y-2 md:gap-y-0 flex flex-col mb-5 md:flex-row md:items-center justify-between">
                <h2 className="text-xl md:text-2xl text-black font-bold">{state?.row?.name + "'s Orders"}</h2>
                <div className="min-w-[30%] flex flex-col md:flex-row items-end md:items-center gap-y-2 md:gap-y-0 md:gap-x-2">
                    <div className="w-full flex items-center justify-between border rounded-xl p-1">
                        <input
                            type="text"
                            placeholder="Search reference"
                            className="w-full bg-transparent focus:outline-none text-gray-700 px-2"
                            value={formFields?.search}
                            onChange={(e) => {setFormFields({...formFields, search: e.target.value}); }}
                        />
                        <button onClick={() => formFields?.search?.length > 0 ? searchData() : getData() } className="hover:opacity-[0.8] bg-primary text-white flex flex-row items-center justify-evenly w-auto h-[35px] px-3 rounded-xl shadow-md shrink-0 text-sm md:text-md">
                            <span className="text-white font-cormorant-bold text-sm md:text-md update-price"><IoSearch /></span>
                        </button>
                    </div>
                </div>
            </div>
            <div className="animate-fadeIn mt-0 w-auto bg-white rounded-3xl border p-6 shadow-sm grid grid-cols-2 md:grid-cols-2">
                <div className="flex-1">
                <label className="flex items-center gap-2 text-gray-500 text-xs md:text-sm mb-1">
                    <MdOutlineWarehouse className="w-5 h-5" />
                    Amount Spent
                </label>

                <div className="relative">
                    <p className="font-bold text-2xl md:text-3xl">{pageData?.total_income}</p>
                </div>
                </div>
                <div className="flex-1">
                <label className="flex items-center gap-2 text-gray-500 text-xs md:text-sm mb-1">
                    <BiMoneyWithdraw className="w-5 h-5" />
                    Items Ordered
                </label>

                <div className="relative">
                    <p className="font-bold text-2xl md:text-3xl">{pageData?.total_orders}</p>
                </div>
                </div>
            </div>
            {/* <div className="flex mt-7 flex-row items-center justify-between">
                
            </div> */}
            <div className='overflow-x-auto mt-5'>
                <table className="w-full table-auto border-collapse text-sm md:text-[15px]">
                    <thead className="bg-gray-50 border-b">
                    <tr>
                        <th className="hidden md:table-cell px-2 py-4">
                            <div className="flex items-center gap-1">#</div>
                        </th>
                        <th className="text-left px-2 py-4 font-medium text-gray-600">
                            <div className="flex items-center gap-1">Reference</div>
                        </th>
                        <th className="text-left px-2 py-4 font-medium text-gray-600">
                            <div className="flex items-center gap-1">Customer Details</div>
                        </th>
                        <th className="text-left px-2 py-4 font-medium text-gray-600">
                            <div className="flex justify-between items-center gap-1">
                                Order Amount
                                <div className="flex flex-col">
                                    <button onClick={() => setFormFields({...formFields, order_by: 'order_amount', order: 'ASC'})} >
                                        <IoMdArrowDropup color={formFields?.order_by == "order_amount" && formFields?.order == "ASC" ? '#585858' : '#bbb'} size={20} />
                                    </button>
                                    <button onClick={() => setFormFields({...formFields, order_by: 'order_amount', order: 'DESC'})}>
                                        <IoMdArrowDropdown color={formFields?.order_by == "order_amount" && formFields?.order == "DESC" ? '#585858' : '#bbb'} size={20} />
                                    </button>
                                </div>
                            </div>
                        </th>
                        <th className="text-left px-2 py-4 font-medium text-gray-600">
                            <div className="flex items-center gap-1">Order Summary</div>
                        </th>
                        <th className="hidden md:table-cell text-left px-2 py-4 font-medium text-gray-600">
                            <div className="flex justify-between items-center gap-1">
                                Time
                                <div className="flex flex-col">
                                    <button onClick={() => setFormFields({...formFields, order_by: 'time', order: 'ASC'})} >
                                        <IoMdArrowDropup color={formFields?.order_by == "time" && formFields?.order == "ASC" ? '#585858' : '#bbb'} size={20} />
                                    </button>
                                    <button onClick={() => setFormFields({...formFields, order_by: 'time', order: 'DESC'})}>
                                        <IoMdArrowDropdown color={formFields?.order_by == "time" && formFields?.order == "DESC" ? '#585858' : '#bbb'} size={20} />
                                    </button>
                                </div>
                            </div>
                        </th>
                        <th></th>
                    </tr>
                    </thead>
                    <tbody className="text-gray-700">
                        {bookingList?.map((row, index) => (
                            <tr
                            key={index}
                            className={index % 2 === 0 ? "bg-white animate-fadeIn" : "bg-gray-50 animate-fadeIn"}
                            >
                                <td className="hidden md:table-cell px-2 py-2">
                                    {++index}
                                </td>
                                <td className="px-2 py-2">
                                    {row.rrr}
                                </td>
                                <td className="px-2 py-2 flex flex-col">
                                    <a className="font-semibold text-sm">{row.full_name}</a>
                                    <a className="text-xs">{row.email}</a>
                                    <a className="text-xs">{row.phone_number}</a>
                                </td>
                                <td className="px-2 py-2">
                                    {row.order_amount}
                                </td>
                                <td className="px-2 py-2 flex flex-col">
                                    {row.order_items?.map((item, index) => 
                                        <a className="text-sm">{++index}{". "}{item.name}</a>
                                    )}
                                </td>
                                <td className="hidden md:table-cell px-2 py-2">
                                    {row.time}
                                </td>
                                <td className="px-2 py-2">
                                    <div className="flex flex-col md:flex-row gap-y-1 md:gap-y-0 gap-x-1">
                                        <div onClick={() => navigate(`/dashboard/order-history/details/${row.rrr}`)} className="flex items-center justify-center cursor-pointer px-2 py-1 md:px-3 md:py-2 rounded-[5px] border border-1 border-primary bg-primary text-white font-semibold text-center text-xs">{'View'}</div>
                                        <div onClick={() => { setShowDetails({ email: row.email, }); setShowEmailModal(true) } } className="flex items-center justify-center cursor-pointer px-2 py-1 md:px-3 md:py-2 rounded-[5px] border border-1 border-[#037684] bg-[#037684] text-white font-semibold text-center text-xs">{'Send Email'}</div>
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <div className='w-full flex justify-end mt-6'>
                <div className='flex flex-col items-center'>
                    <div className="flex items-center space-x-2 border border-gray-300 rounded-lg px-1 py-1 w-fit bg-white">
                        <button
                            onClick={() => changePage('prev')}
                            className="text-sm font-semibold px-3 py-1 rounded bg-gray-100 hover:bg-gray-200"
                        >
                            Prev.
                        </button>
                        <button
                            onClick={() => changePage('next')}
                            className="text-sm font-semibold px-3 py-1 rounded bg-gray-100 hover:bg-gray-200"
                        >
                            Next
                        </button>
                    </div> 
                    <label className='text-sm mt-2'>{pagination}</label>
                </div>
            </div>
        </div>
    </div>
  );
}
